import React, { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";
import "./mandatory.css";
const API_URL = "https://api.npskudlu.com/api";

const DocButton = ({ href, label = "PDF" }) => {
  return href ? (
    <a
      className="ma-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open ${label}`}
      onClick={(e) => {
        e.preventDefault();
        window.open(href, "_blank");
      }}
    >
      <svg viewBox="0 0 24 24" aria-hidden className="ma-icon">
        <path
          d="M12 2v7h7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 22h14a1 1 0 0 0 1-1V6L13 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span>{label}</span>
    </a>
  ) : (
    <button className="ma-btn ma-btn-disabled" disabled aria-disabled="true">
      <svg viewBox="0 0 24 24" aria-hidden className="ma-icon">
        <path
          d="M12 2v7h7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 22h14a1 1 0 0 0 1-1V6L13 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span>PDF</span>
    </button>
  );
};

/* Generic Table Card */
const TableCard = ({ title, columns, rows }) => {
  return (
    <section className="ma-card" aria-labelledby={title.replace(/\s+/g, "-")}>
      <h3 id={title.replace(/\s+/g, "-")} className="ma-card-title">
        {title}
      </h3>
      <div className="ma-table-wrap">
        <table className="ma-table">
          <thead>
            <tr>
              {columns.map((c, idx) => (
                <th key={idx}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rIdx) => (
              <tr key={rIdx}>
                {row.map((cell, cIdx) => (
                  <td key={cIdx} className={cIdx === 0 ? "ma-td-small" : ""}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

const Mandatory = () => {
  const [documents, setDocuments] = useState([]);
  const [generalInfo, setGeneralInfo] = useState("");
  const [staff, setStaff] = useState("");
  const [infrastructure, setInfrastructure] = useState("");
  const [academics, setAcademics] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDoc = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${API_URL}/v1/get-document`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data) {
        setDocuments(response.data.data);
      } else {
        setDocuments([]);
      }
    } catch (err) {
      console.error("Document fetch failed:", err);

      setError("Failed to load documents.");

      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchInfo = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${API_URL}/v1/get-general-info`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data) {
        setGeneralInfo(response.data.data);
      } else {
        setGeneralInfo([]);
      }
    } catch (err) {
      console.error("Info fetch failed:", err);

      setError("Failed to load general information.");

      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${API_URL}/v1/get-staff`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data) {
        setStaff(response.data.data);
      } else {
        setStaff([]);
      }
    } catch (err) {
      console.error("Info fetch failed:", err);

      setError("Failed to load staff information.");

      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchInfrastructure = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${API_URL}/v1/get-infrastructure`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data) {
        setInfrastructure(response.data.data);
      } else {
        setInfrastructure([]);
      }
    } catch (err) {
      console.error("Info fetch failed:", err);

      setError("Failed to load infrastructure information.");

      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchAcademics = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${API_URL}/v1/get-academics`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data) {
        setAcademics(response.data.data);
      } else {
        setAcademics([]);
      }
    } catch (err) {
      console.error("Info fetch failed:", err);

      setError("Failed to load academics information.");

      setDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDoc();
    fetchInfo();
    fetchStaff();
    fetchInfrastructure();
    fetchAcademics();
  }, []);


  const generalRows = [
    ["1.", "NAME OF THE SCHOOL", generalInfo?.schoolName || "-"],
    [
      "2.",
      "COMPLETE ADDRESS WITH PIN CODE",
      generalInfo?.address || "-"
    ],
    [
      "3.",
      "PRINCIPAL NAME",
      generalInfo?.principalName || "-"
    ],
    [
      "4.",
      "PRINCIPAL QUALIFICATION",
      generalInfo?.qualification || "-"
    ],
    [
      "5.",
      "SCHOOL EMAIL ID",
      generalInfo?.email
        ? generalInfo.email.split(",").map((email, index) => (
          <div key={index}>{email.trim()}</div>
        ))
        : "-"
    ],
    [
      "6.",
      "CONTACT DETAILS (LANDLINE / MOBILE)",
      generalInfo?.mobileNumber
        ? generalInfo.mobileNumber.split(",").map((mobile, index) => (
          <div key={index}>{mobile.trim()}</div>
        ))
        : "-"
    ]
  ];

  const docsRows = documents.map((item, index) => [
    `${index + 1}.`,
    item?.title || "-",

    <DocButton
      href={item?.file?.url}
      label={item?.type?.toUpperCase() || "FILE"}
    />,
  ]);

  const resultRows = [
    [
      "1.",
      "FEE STRUCTURE OF THE SCHOOL",
      <DocButton href={academics?.feestructure} />
    ],
    ["2.", "ANNUAL ACADEMIC CALENDAR", <DocButton href={academics?.calendar} />],
    [
      "3.",
      "LIST OF SCHOOL MANAGEMENT COMMITTEE",
      <DocButton href={academics?.smc} />,
    ],
    [
      "4.",
      "LIST OF PARENT TEACHERS ASSOCIATION MEMBERS",
      <DocButton href={academics?.pta} />,
    ],
  ];

  const principalParts = staff?.principal?.split(",");

  const counsellorParts = staff?.counsellor?.split(",");

  const staffRows = [
    [
      "1.",
      "PRINCIPAL",
      <>
        {principalParts?.[0]?.trim() || "-"}
        <br />
        <span className="ma-muted">
          {principalParts?.slice(1).join(", ").trim()}
        </span>
      </>,
    ],
    [
      "2.",
      "TOTAL NUMBER OF TEACHERS",
      `${staff?.totalTeachers || 0}`,
    ],
    ["", "PGT", staff?.pgt || "0"],
    ["", "TGT", staff?.tgt || "0"],
    ["", "PRT", staff?.prt || "0"],
    ["", "NTT", staff?.ntt || "0"],
    [
      "3.",
      "TEACHERS SECTION RATIO",
      staff?.ratio || "-",
    ],
    [
      "4.",
      "DETAILS OF SPECIAL EDUCATOR",
      staff?.specialEducator || "-",
    ],
    [
      "5.",
      "DETAILS OF COUNSELLOR AND WELLNESS TEACHER",
      <>
        {counsellorParts?.[0]?.trim() || "-"}
        <br />
        <span className="ma-muted">
          {counsellorParts?.slice(1).join(", ").trim()}
        </span>
      </>,
    ],
  ];

  const infraRows = [
    [
      "1.",
      "TOTAL CAMPUS AREA OF THE SCHOOL (SQ MTR)",
      infrastructure?.totalArea || "-"
    ],
    [
      "2.",
      "NUMBER AND SIZE OF THE CLASS ROOMS (SQ MTR)",
      `${infrastructure?.totalClassRoom || "-"} – ${infrastructure?.classRoomSize || "-"
      }`
    ],
    [
      "3.",
      "NUMBER AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (SQ MTR)",
      infrastructure?.labs
        ? infrastructure.labs.split(",").map((lab, index) => (
          <div key={index}>{lab.trim()}</div>
        ))
        : "-"
    ],
    [
      "4.",
      "INTERNET FACILITY",
      infrastructure?.internet || "-"
    ],
    [
      "5.",
      "NUMBER OF GIRLS TOILETS",
      infrastructure?.girlToilet || "-"
    ],
    [
      "6.",
      "NUMBER OF BOYS TOILETS",
      infrastructure?.boysToilet || "-"
    ],
    [
      "7.",
      "YouTube Link",
      infrastructure?.youtubeLink || "-"
    ]
  ];
  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Mandatory Public Disclosure"} />
        <section className="about-two py-60 position-relative z-1">
          <div className="position-relative">
            <div className="container">
              <div className="ma-grid container">
                <div className="ma-col-full">
                  <TableCard
                    title="General Information"
                    columns={["Sl No", "Information", "Details"]}
                    rows={generalRows}
                  />
                </div>
                <div className="ma-col-full">
                  <TableCard
                    title="Documents and Information (PDF)"
                    columns={["Sl No", "Documents / Information", "Details"]}
                    rows={docsRows}
                  />
                </div>
                <div className="ma-col-full">
                  <TableCard
                    title="Result and Academics"
                    columns={["Sl No", "Documents / Information", "Details"]}
                    rows={resultRows}
                  />
                </div>
                <div className="ma-col-full">
                  <TableCard
                    title="Staff (Teaching)"
                    columns={["Sl No", "Documents / Information", "Details"]}
                    rows={staffRows}
                  />
                </div>

                <div className="ma-col-full">
                  <TableCard
                    title="School Infrastructure"
                    columns={["Sl No", "Documents / Information", "Details"]}
                    rows={infraRows}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Mandatory;
